import {
    pathFascicoloHome,
    pathFascicoloAdd,
    pathAnagraficaHome,
    pathAnagraficaImportDesktop,
    pathPrestazioneHome,
    pathRischioHome,
    pathSegnalazioneHome,  
    pathAutoValutazioneHome,
    pathAutoValutazioneAdd,
    pathNormativaHome,
    pathImpTabBaseHome,
    pathImpUtenteHome,
    pathImpAuditHome,
    pathAziendaHome,
    pathAziendaAdd,
    pathReleaseNotesHome,
    pathExportDatiHome,
    pathNominationHome,
} from "../constants/path";

export const ACTIVITY_ROUTE_MAP = {
    [pathAziendaHome]: { path: pathAziendaHome, storageSetterKey: null },
    [pathAziendaAdd]: { path: pathAziendaAdd, storageSetterKey: 'setSelectedAzienda' },
    [pathFascicoloHome]: { path: pathFascicoloHome, storageSetterKey: null },
    [pathFascicoloAdd]: { path: pathFascicoloAdd, storageSetterKey: 'setSelectedFascicolo' },
    [pathAnagraficaHome]: { path: pathAnagraficaHome, storageSetterKey: null },
    [pathPrestazioneHome]: { path: pathPrestazioneHome, storageSetterKey: null },
    [pathRischioHome]: { path: pathRischioHome, storageSetterKey: null },
    [pathAutoValutazioneHome]: { path: pathAutoValutazioneHome, storageSetterKey: null },
    [pathAutoValutazioneAdd]: { path: pathAutoValutazioneAdd, storageSetterKey: 'setSelectedAutovalutazione' },
    [pathSegnalazioneHome]: { path: pathSegnalazioneHome, storageSetterKey: null },
    [pathNormativaHome]: { path: pathNormativaHome, storageSetterKey: null },
    [pathImpTabBaseHome]: { path: pathImpTabBaseHome, storageSetterKey: null },
    [pathImpUtenteHome]: { path: pathImpUtenteHome, storageSetterKey: null },
    [pathImpAuditHome]: { path: pathImpAuditHome, storageSetterKey: null },
    [pathReleaseNotesHome]: { path: pathReleaseNotesHome, storageSetterKey: null },
    [pathExportDatiHome]: { path: pathExportDatiHome, storageSetterKey: null },
    [pathNominationHome]: { path: pathNominationHome, storageSetterKey: null },
};

export const LastActivityHelpers = () => {
    
    const NavigateFromLastActivity = (lastActivity, navigate, storageSetters) => {
        if (!lastActivity?.path) return;

        const routeConfig = ACTIVITY_ROUTE_MAP[lastActivity.path];
        if (!routeConfig) return;

        // Execute storage setter if configured and entityId is present
        if (routeConfig.storageSetterKey && lastActivity.entityId && storageSetters[routeConfig.storageSetterKey]) {
            storageSetters[routeConfig.storageSetterKey](parseInt(lastActivity.entityId));
        }

        // Navigate to the path
        navigate(routeConfig.path);
    };
    const GetLastActivityAreaByPath = (path) => {
        if (!path) return "";
        let area = "";
        switch (path) {
            case pathAziendaHome: {
                area = "Gestione Aziende";
                break;
            }
            case pathAziendaAdd: {
                area = "Gestione Azienda";
                break;
            }
            case pathFascicoloHome: {
                area = "Gestione Fascicoli";
                break;
            }
            case pathFascicoloAdd: {
                area = "Gestione Fascicolo";
                break;
            }
            case pathAnagraficaHome: {
                area = "Gestione Anagrafiche";
                break;
            }
            case pathPrestazioneHome: {
                area = "Gestione Prestazioni";
                break;
            }
            case pathRischioHome: {
                area = "Gestione Valutazioni rischio";
                break;
            }
            case pathAutoValutazioneHome: {
                area = "Gestione Autovalutazioni del rischio";
                break;
            }
            case pathAutoValutazioneAdd: {
                area = "Gestione Autovalutazione del rischio";
                break;
            }
            case pathSegnalazioneHome: {
                area = "Gestione Segnalazioni di operazione sospetta";
                break;
            }
            case pathNormativaHome: {
                area = "Consultazione Normativa";
                break;
            }
            case pathImpTabBaseHome: {
                area = "Gestione Tabelle di base";
                break;
            }
            case pathImpUtenteHome: {
                area = "Gestione Utenti";
                break;
            }
            case pathImpAuditHome: {
                area = "Consultazione Audit";
                break;
            }
            case pathReleaseNotesHome: {
                area = "Consultazione Note di Rilascio";
                break;
            }
            case pathExportDatiHome: {
                area = "Export dati";
                break;
            }
            case pathNominationHome: {
                area = "Nomina dei ruoli";
                break;
            }
            case pathAnagraficaImportDesktop: {
                area = "Import Anagrafiche da antiriciclaggio desktop";
                break;
            }
            default:
                break;
        }
        return area;
    };

    return {
        GetLastActivityAreaByPath,
        NavigateFromLastActivity
    }
};

export default LastActivityHelpers;